<!-- 横向导航栏 -->
<style scoped>
    .logo{
        width: 6rem; 
        z-index: 1000;
    }
    .menu-slide:hover>.menu-slide-item,.menu-slide-item:hover {
        display: block;
    }
    .menu-slide-item>span{
        visibility: hidden;
        opacity: 0;
    }
    .menu-slide:hover>.menu-slide-item>span:nth-of-type(1){
        visibility:visible;
        animation: menu-slide 0.2s ease-in-out forwards;
    }
    .menu-slide:hover>.menu-slide-item>span:nth-of-type(2){
        visibility:visible;
        animation: menu-slide 0.2s ease-in-out forwards;
        animation-delay: 0.1s;
    }
    .menu-slide:hover>.menu-slide-item>span:nth-of-type(3){
        visibility:visible;
        animation: menu-slide 0.2s ease-in-out forwards;
        animation-delay: 0.2s;
    }
    .menu-slide:hover>.menu-slide-item>span:nth-of-type(4){
        visibility:visible;
        animation: menu-slide 0.2s ease-in-out forwards;
        animation-delay: 0.3s;
    }
    .menu-slide:hover>.menu-slide-item>span:nth-of-type(5){
        visibility:visible;
        animation: menu-slide 0.2s ease-in-out forwards;
        animation-delay: 0.4s;
    }
    .menu-slide:hover>.menu-slide-item>span:nth-of-type(6){
        visibility:visible;
        animation: menu-slide 0.2s ease-in-out forwards;
        animation-delay: 0.5s;
    }
    .notice-border::before{
        content: "";
        position: absolute;
        height: 1px;
        width: 100%;
        top:0;
        background: linear-gradient(90deg,transparent,#fff);
    }
    .notice-border::after{
        content: "";
        position: absolute;
        height: 1px;
        width: 100%;
        bottom:0;
        background: linear-gradient(90deg,rgb(255, 255, 116),transparent);
    }
    @keyframes menu-slide {
        0% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
    @media (min-width: 576px){
        .logo{
            width: 8rem;
        }
    }
</style>
<template>
    <div class="positoin-relative">
        <header class="py-1 px-2 px-sm-3 pt-sm-0 pb-sm-0 position-relative index-2">
            <div class="w-100 d-flex flex-wrap justify-content-between my-sm-1 my-md-2">
                <div class="d-flex flex-column justify-content-center">
                    <img class="d-none d-sm-block logo me-2 me-sm-3" src="logo.png" alt="">
                </div>
                <div class="d-flex flex-grow-1">
                    <div class="w-0 d-flex flex-column flex-grow-1 text-light mt-0 justify-content-between">
                        <div class="d-flex align-items-center flex-grow-1 position-relative">
                            <img class="d-block d-sm-none logo me-2 me-sm-3" src="logo.png" alt="">
                            <notice class="bg-transparent notice-border position-relative position-sm-absolute" style="background: linear-gradient(0.2deg, #ffff74, transparent 12%),linear-gradient(180.2deg, #fff, transparent 12%),linear-gradient(90deg,transparent 0%,#212529 15%,#212529 85%,transparent);"></notice>
                        </div>
                        <!-- 用户信息 -->
                        <div class="d-flex align-content-center mt-1 ms-1 ms-sm-0 position-relative lh-1">
                            <div v-if="$route.name!='home'&&$route.name!='personal'" class="d-flex align-items-center me-2 d-sm-none flex-fill fw-bold text-primary" @click="$root.goPage('home')">
                                <i class="bi bi-house-fill me-1"></i>
                                <span>{{$t("nav.home")}}</span>
                            </div>
                            <div class="me-sm-2 d-flex align-items-center flex-fill flex-sm-grow-0">
                                <i class="bi bi-person-circle me-1 text-info"></i>
                                <span class="align-middle">{{userInfo.id}}</span>
                            </div>
                            <!-- 金币 -->
                            <div v-if="!($route.name=='share'||gameModel==GAME_MODEL.tel)" class="me-sm-2 d-flex align-items-center flex-fill flex-sm-grow-0 position-relative hover-tip">
                                <div class="rounded-circle bg-warning w-1rem h-1rem d-flex justify-content-center align-items-center text-primary me-2" style="background:linear-gradient(90deg, #6b6b00, yellow);box-shadow: -.1rem 0 0 #fff inset, 0 0 0 .1rem #d5d500 inset, .15rem 0 0 #999900, .2rem 0 0 #2a2a2a;transform: rotateY(15deg) rotateZ(15deg);">
                                    <i class="bi bi-suit-spade-fill" style="color:#404000;transform: scale(.6);text-shadow: #000 .1rem 0 .1rem"></i>
                                </div>
                                <span class="align-middle">{{userInfo.realCoin}}</span>
                                <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 lh-1 text-nowrap tip-content d-none">金币：玩家与平台博弈使用的积分</div>
                            </div>
                            <!-- 银币 -->
                            <div v-if="!($route.name=='share'||gameModel==GAME_MODEL.tel)" class="me-sm-2 d-flex align-items-center flex-fill flex-sm-grow-0 position-relative hover-tip">
                                <div class="rounded-circle bg-warning w-1rem h-1rem d-flex justify-content-center align-items-center text-primary me-2" style="background:linear-gradient(90deg, #56565f, #E6E6FA);box-shadow: -.1rem 0 0 #fff inset, 0 0 0 .1rem #bbbbc9 inset, .15rem 0 0 #8c8c99, .2rem 0 0 #2a2a2a;transform: rotateY(15deg) rotateZ(15deg);">
                                    <i class="d-flex bi bi-suit-heart-fill" style="color:#db0000;transform: scale(.55);text-shadow: #830000 .1rem 0 .1rem"></i>
                                </div>
                                <span class="align-middle">{{userInfo.esportsCoin}}</span>
                                <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 lh-1 text-nowrap tip-content d-none">银币：玩家与玩家竞技使用的积分</div>
                            </div>
                            <!-- 代券 -->
                            <div v-if="IS_HAVE_TICKET||(userInfo.ticket&&userInfo.ticket.length)>0" class="d-flex align-items-center position-relative hover-tip">
                                <div class="rounded-_1rem w-1_2rem h-_8rem me-2 text-light small d-flex justify-content-end align-items-center" style="background: linear-gradient(0deg,#007dc9 20%, #ffa500 20%,#ffa500 40%, #007dc9 40%,#007dc9 60%, #ffa500 60%,#ffa500 80%, #007dc9 80% ) 29.35% .12rem/1px .64rem no-repeat,radial-gradient(circle at 30% 0, transparent .1rem, #ffa500 .1rem) 0 0/100% 55% no-repeat,radial-gradient(circle at 30% 100%, transparent .1rem, #ffa500 .1rem) 0 bottom/100% 50% no-repeat,linear-gradient(0deg,transparent,#fff,transparent);">
                                    <span class="fs-_6rem lh-1 me-1 fw-bold">¥</span>
                                </div>
                                <div class="d-flex align-items-center small">
                                    <span v-if="userInfo.ticket&&userInfo.ticket.length>0" @click="$root.setCurrModal('我的代券')" class="rounded-pill btn-success-1 fw-bold fs-_6rem px-1 py-_15rem">查看{{(userInfo.ticket&&userInfo.ticket.length)||0}}张</span>
                                    <span v-else class="rounded-pill btn-secondary-1 fw-bold fs-_6rem px-1 py-_15rem">暂无代券</span>
                                </div>
                                <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 lh-1 text-nowrap tip-content d-none">代券：可代替金币/银币使用的券</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-center">
                    <div class="d-sm-none dropdown menu-slide">
                        <button class="btn btn-outline-light ms-2 px-2 py-1 position-relative" :class="{'index-1053':$root.teachIndex==2&&$root.isShowTeach}" type="button">
                            <i class="bi bi-list"></i>
                        </button>
                        <div class="dropdown-menu bg-cyan p-2 pb-0 text-center rounded-3 min-w-0 shadow menu-slide-item end-0">
                            <span v-show="['bac','cor'].indexOf($route.name)!=-1" class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" role="button" @click="$root.goPage('personal')">{{$t("nav.personal")}}</span>
                            <span v-if="$route.name!='share'" class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setCurrModal($t('nav.network'))" role="button">{{$t("nav.network")}}</span>
                            <span class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setCurrModal($t('nav.sound'))" role="button">{{$t("nav.sound")}}</span>
                            <span v-if="$route.name!='share'" class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setFullscreen" role="button">{{isFullscreen?$t("login.unFullscreen"):$t("login.fullscreen")}}</span>
                            <span v-if="$route.name!='share'" class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setCurrModal('公告')" role="button">公告</span>
                            <span v-if="$route.name!='share'" class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.logout" role="button">{{$t("nav.logout")}}</span>
                            <!-- <span v-show="['bac','cor'].indexOf($route.name)!=-1" class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" role="button" @click="$root.goPage('home')">{{$t("nav.home")}}</span> -->
                        </div>
                    </div>
                </div>
                <div class="d-sm-flex d-none text-center fw-bold justify-content-end align-items-center">
                    <div class="ps-3" :class="{'index-1053':$root.teachIndex==0&&$root.isShowTeach}">
                        <div class="text-light d-flex flex-column align-items-center align-items-center" role="button" @click="$root.goPage('help')">
                            <i class="bi bi-chat-dots-fill fs-3 text-info position-relative">
                                <span v-show="hasChatMsg" class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"></span>
                            </i>
                            <span>{{$t("nav.chat")}}</span>
                        </div>
                    </div>
                    <div class="ps-3" :class="{'index-1053':$root.teachIndex==1&&$root.isShowTeach}">
                        <div class="text-light d-flex flex-column align-items-center align-items-center" role="button" @click="$root.goPage('personal')">
                            <i class="bi bi-x-diamond-fill fs-3 text-info"></i>
                            <span>{{$t("nav.personal")}}</span>
                        </div>
                    </div>
                    <div class="ps-3 dropdown menu-slide" :class="{'index-1053':$root.teachIndex==2&&$root.isShowTeach}">
                        <span class="text-light d-flex flex-column align-items-center align-items-center" role="button">
                            <i class="bi bi-gear-fill fs-3 text-info"></i>
                            <span>{{$t("nav.settings")}}</span>
                        </span>
                        <div class="dropdown-menu bg-cyan p-2 text-center rounded-3 min-w-0 shadow menu-slide-item translate-middle-x">
                            <span class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setCurrModal($t('nav.network'))" role="button">{{$t("nav.network")}}</span>
                            <span class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setCurrModal($t('nav.sound'))" role="button">{{$t("nav.sound")}}</span>
                            <span class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setFullscreen" role="button">{{isFullscreen?$t("login.unFullscreen"):$t("login.fullscreen")}}</span>
                            <span class="dropdown-item text-light border border-info bg-cyan mb-2 rounded-3 px-4 py-2 shadow" @click="$root.setCurrModal('公告')" role="button">公告</span>
                            <span class="dropdown-item text-light border border-info bg-cyan rounded-3 px-4 py-2 shadow" @click="$root.logout" role="button">{{$t("nav.logout")}}</span>
                        </div>
                    </div>
                    <div class="ps-3">
                        <span class="text-light d-flex flex-column align-items-center align-items-center" role="button" @click="goHome">
                            <i class="bi bi-house-fill fs-3 text-info"></i>
                            <span>{{$t("nav.home")}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>
<script>
import { MUTATION_TYPE,GAME_MODEL,IS_HAVE_TICKET } from "@/assets/js/config.js"
import { guid } from "@/assets/js/common.js"
import { useLayer } from '@/assets/js/useLayer'
import notice from '@/components/public/notice.vue';
export default {
    components:{
        notice
    },
    props:{
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
        hasChatMsg:false,//是否有未读的客服消息
    },
    inject: {
        notice:{
            default:''
        },//公告内容
    },
    data(){
        return {
            IS_HAVE_TICKET,
            GAME_MODEL,
            guid:guid(),
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        // videoLineList(){
        //     return this.$store.state.videoLineList;
        // },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        audioSwitch(){
            return this.$store.state.audioSwitch;
        },
        gameModel(){
            return this.$store.state.gameModel;
        }
    },
    methods:{
        goHome(){
            if(this.$attrs['onGoHomeBefore']){//有事件前守卫则执行事件
                this.$emit('go-home-before',(isCanGoHome)=>{//是否能去往大厅
                    if(isCanGoHome){
                        this.$root.goPage('home');
                    }
                });
            }else{
                this.$root.goPage('home');
            }
        },
        /**
         * 改变音效开关
         */
        changeAudioSwitch(type,isOpen){
            this.$store.commit({
                type:MUTATION_TYPE.setAudioSwitch,
                audioSwitch:{
                    [type]:isOpen
                }
            })
        },
    },
    watch: {
        /**
         * 监听视频线路列表变化
         */
        // videoLineList(newVal) {
            // if(newVal.length>0){
            //     let obj = newVal.find(v=>v.type=="IOS");
            //     if(this.$root.getSystem()=="ios"&&obj){//ios系统如果有IOS线路则使用IOS线路
            //         this.currVideoLine=obj.id;
            //     }else{
            //         this.currVideoLine=newVal[0].id;
            //     }
            //     this.$emit('set-curr-video-line',newVal[0].id);
            // }
        // },
    },
}
</script>